import * as React from 'react';
import classNames from 'classnames';
import { FocusTrapZone } from 'office-ui-fabric-react/lib/FocusTrapZone';
import { Panel } from 'office-ui-fabric-react/lib/Panel';

const styles = require('./AddinPanel.scss');

export interface AddinPanelProps {
    renderInPanel: boolean;
    onDismiss: () => void;
    isDeepLink: boolean;
    disableFirstFocus: boolean;
    children?: React.ReactNode;
}

export const AddinPanel: React.StatelessComponent<AddinPanelProps> = (props: AddinPanelProps) => {
    if (props.renderInPanel) {
        return (
            <Panel
                focusTrapZoneProps={{
                    forceFocusInsideTrap: false,
                    disableFirstFocus: props.disableFirstFocus,
                    isClickableOutsideFocusTrap: true,
                }}
                hasCloseButton={false}
                isOpen={true}
                onDismiss={props.onDismiss}
                className={classNames(styles.taskPane, props.isDeepLink && styles.taskPaneNoHeader)}
                isBlocking={false}
                isFooterAtBottom={true}
                isLightDismiss={true}>
                {props.children}
            </Panel>
        );
    } else {
        return (
            <FocusTrapZone
                forceFocusInsideTrap={false}
                isClickableOutsideFocusTrap={true}
                className={styles.taskPane}>
                {props.children}
            </FocusTrapZone>
        );
    }
};
